import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _regeneratorRuntime from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/ubuntu/Local-Stitch-Front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import React, { useState } from 'react';
import { PostPartnerShipAPI } from 'api/application';
import { getAPIErrorMessage } from 'utils';
import { AgreeMessage, CORRECT_PHONE_MSG, EMAIL_UNMATCH_MSG, RequiredMessage } from 'constants/message';
import { isEmail, isPhone } from 'constants/reg';

var ModalPartnership = function ModalPartnership(_ref) {
  var closeModal = _ref.closeModal;

  // post value
  var _useState = useState(''),
      name = _useState[0],
      setName = _useState[1];

  var _useState2 = useState(''),
      phone = _useState2[0],
      setPhone = _useState2[1];

  var _useState3 = useState(''),
      email = _useState3[0],
      setEmail = _useState3[1];

  var _useState4 = useState(''),
      content = _useState4[0],
      setContent = _useState4[1];

  var _useState5 = useState(false),
      agree = _useState5[0],
      setAgree = _useState5[1]; // Help Value


  var _useState6 = useState(''),
      nameHelp = _useState6[0],
      setNameHelp = _useState6[1];

  var _useState7 = useState(''),
      phoneHelp = _useState7[0],
      setPhoneHelp = _useState7[1];

  var _useState8 = useState(''),
      emailHelp = _useState8[0],
      setEmailHelp = _useState8[1];

  var _useState9 = useState(''),
      cntHelp = _useState9[0],
      setCntHelp = _useState9[1]; // onChange


  var onChangeName = function onChangeName(event) {
    return setName(event.target.value);
  };

  var onChangePhone = function onChangePhone(event) {
    return setPhone(event.target.value);
  };

  var onChangeEmail = function onChangeEmail(event) {
    return setEmail(event.target.value);
  };

  var onChangeContent = function onChangeContent(event) {
    return setContent(event.target.value);
  };

  var onChangeAgree = function onChangeAgree(event) {
    return setAgree(event.target.checked);
  }; // click


  var clickRequest = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var partnership, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (validate()) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              partnership = {
                name: name,
                phone_number: phone,
                email: email,
                content: content
              };
              _context.next = 5;
              return PostPartnerShipAPI(partnership);

            case 5:
              response = _context.sent;

              if (!(response.status >= 400)) {
                _context.next = 9;
                break;
              }

              alert(getAPIErrorMessage(response));
              return _context.abrupt("return");

            case 9:
              window.location.reload();

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function clickRequest() {
      return _ref2.apply(this, arguments);
    };
  }(); // validate


  var validate = function validate() {
    if (!name.length) {
      document.getElementById('name').focus();
      setNameHelp(RequiredMessage('이름'));
      return false;
    }

    setNameHelp('');

    if (!phone.length) {
      document.getElementById('tell').focus();
      setPhoneHelp(RequiredMessage('연락처'));
      return false;
    }

    setPhoneHelp('');

    if (!email.length) {
      document.getElementById('eMail').focus();
      setEmailHelp(RequiredMessage('이메일'));
      return false;
    }

    setEmailHelp('');

    if (!content.length) {
      document.getElementById('cnts').focus();
      setCntHelp(RequiredMessage('내용'));
      return false;
    }

    setCntHelp('');

    if (!isPhone(phone)) {
      document.getElementById('tell').focus();
      setPhoneHelp(CORRECT_PHONE_MSG);
      return false;
    }

    setPhoneHelp('');

    if (!isEmail(email)) {
      document.getElementById('eMail').focus();
      setEmailHelp(EMAIL_UNMATCH_MSG);
      return false;
    }

    setEmailHelp('');

    if (!agree) {
      alert(AgreeMessage('개인정보 및 수집이용'));
      return false;
    }

    return true;
  };

  return /*#__PURE__*/_jsx("div", {
    className: "dimd-layer",
    children: /*#__PURE__*/_jsx("div", {
      className: "inner sz-type",
      children: /*#__PURE__*/_jsxs("section", {
        className: "invite-w",
        children: [/*#__PURE__*/_jsx("h1", {
          children: "\uD30C\uD2B8\uB108\uC2ED \uBB38\uC758"
        }), /*#__PURE__*/_jsxs("div", {
          className: "form-w",
          children: [/*#__PURE__*/_jsxs("label", {
            htmlFor: "name",
            children: ["\uC774\uB984", /*#__PURE__*/_jsx("i", {
              className: "ness",
              children: /*#__PURE__*/_jsx("span", {
                children: "\uD544\uC218\uC785\uB825"
              })
            })]
          }), /*#__PURE__*/_jsx("input", {
            type: "text",
            id: "name",
            placeholder: "\uC774\uB984\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694",
            title: "\uC774\uB984\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694",
            value: name,
            onChange: onChangeName
          }), nameHelp !== '' ? /*#__PURE__*/_jsx("p", {
            className: "err",
            children: nameHelp
          }) : null, /*#__PURE__*/_jsxs("label", {
            htmlFor: "tell",
            children: ["\uC5F0\uB77D\uCC98", /*#__PURE__*/_jsx("i", {
              className: "ness",
              children: /*#__PURE__*/_jsx("span", {
                children: "\uD544\uC218\uC785\uB825"
              })
            })]
          }), /*#__PURE__*/_jsx("input", {
            type: "text",
            id: "tell",
            placeholder: "000-0000-0000",
            title: "000-0000-0000",
            value: phone,
            onChange: onChangePhone
          }), phoneHelp !== '' ? /*#__PURE__*/_jsx("p", {
            className: "err",
            children: phoneHelp
          }) : null, /*#__PURE__*/_jsxs("label", {
            htmlFor: "eMail",
            children: ["\uC774\uBA54\uC77C", /*#__PURE__*/_jsx("i", {
              className: "ness",
              children: /*#__PURE__*/_jsx("span", {
                children: "\uD544\uC218\uC785\uB825"
              })
            })]
          }), /*#__PURE__*/_jsx("input", {
            type: "text",
            id: "eMail",
            placeholder: "mail@mail.com",
            value: email,
            onChange: onChangeEmail
          }), emailHelp !== '' ? /*#__PURE__*/_jsx("p", {
            className: "err",
            children: emailHelp
          }) : null, /*#__PURE__*/_jsxs("label", {
            htmlFor: "cnts",
            children: ["\uB0B4\uC6A9", /*#__PURE__*/_jsx("i", {
              className: "ness",
              children: /*#__PURE__*/_jsx("span", {
                children: "\uD544\uC218\uC785\uB825"
              })
            })]
          }), /*#__PURE__*/_jsx("textarea", {
            id: "cnts",
            placeholder: "\uB0B4\uC6A9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694",
            value: content,
            onChange: onChangeContent
          }), cntHelp !== '' ? /*#__PURE__*/_jsx("p", {
            className: "err",
            children: cntHelp
          }) : null]
        }), /*#__PURE__*/_jsxs("div", {
          className: "agree-box",
          children: [/*#__PURE__*/_jsxs("p", {
            children: [/*#__PURE__*/_jsx("input", {
              type: "checkbox",
              id: "agree",
              checked: agree,
              onChange: onChangeAgree
            }), /*#__PURE__*/_jsx("label", {
              htmlFor: "agree",
              children: "\uAC1C\uC778\uC815\uBCF4 \uC218\uC9D1 \uBC0F \uC774\uC6A9\uC5D0 \uB3D9\uC758\uD569\uB2C8\uB2E4"
            })]
          }), /*#__PURE__*/_jsxs("ul", {
            children: [/*#__PURE__*/_jsx("li", {
              children: "\uC218\uC9D1\xB7\uC774\uC6A9 \uBAA9\uC801 : \uB85C\uCEEC\uC2A4\uD2F0\uCE58 \uD30C\uD2B8\uB108\uC2ED \uBB38\uC758 \uBC0F \uC0C1\uB2F4"
            }), /*#__PURE__*/_jsx("li", {
              children: "\uC218\uC9D1\xB7\uC774\uC6A9 \uD56D\uBAA9 : \uC774\uB984, \uD734\uB300\uD3F0 \uBC88\uD638, \uC774\uBA54\uC77C \uC8FC\uC18C"
            }), /*#__PURE__*/_jsx("li", {
              children: "\uC218\uC9D1\xB7\uC774\uC6A9 \uAE30\uAC04 : \uC2E0\uCCAD\uC77C\uB85C\uBD80\uD130 \uC0C1\uB2F4\uC644\uB8CC\uC77C\uAE4C\uC9C0"
            })]
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "ly-btn",
          children: /*#__PURE__*/_jsx("a", {
            onClick: clickRequest,
            style: {
              cursor: 'pointer'
            },
            children: "\uBB38\uC758\uD558\uAE30"
          })
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          className: "btn-close",
          onClick: closeModal,
          children: /*#__PURE__*/_jsx("span", {
            children: "\uD31D\uC5C5 \uB2EB\uAE30"
          })
        })]
      })
    })
  });
};

export default ModalPartnership;